import { useState } from 'react';
import { createEditor } from 'slate';
import { withHistory } from 'slate-history';
import { withReact } from 'slate-react';

import { withPreviousSelection } from 'src/lib/slate/plugins/withPreviousSelection';

import {
  withDividers,
  withHtml,
  withInlines,
  withLists,
  withMarkUserChanges,
  withNewLine,
  withNormalizedPlaceholder,
  withParagraphs,
  withPromptTags,
  withVariationBlocks,
} from './plugins';
import { applyPlugins } from './utils';

const PLUGINS = [
  withReact,
  withHistory,
  withLists,
  withParagraphs,
  withHtml,
  withDividers,
  withNormalizedPlaceholder,
  withNewLine,
  withVariationBlocks,
  withInlines,
  withPreviousSelection,
  withPromptTags,
  withMarkUserChanges,
];

/**
 * Create Slate editor instance with plugins
 * @param {object} [options] - editor options
 * @param {SLATE_TEXT_FORMATS} [options.defaultTextFormat] - default text format
 * @param {boolean} [options.markUserChanges] - stamp inserted text with the 'user' highlight mark
 * @returns {*}
 */
export const useRichSlateEditor = (options = undefined) => {
  const [editor] = useState(() => applyPlugins(createEditor(), PLUGINS, options));
  return editor;
};
